import Vue from 'vue';

const mutations = {
  SET_CLASSES: (state, classes) => {
    state.classes = classes;
  },

  SET_NEAREST_CLASSES: (state, classes) => {
    state.nearestClasses = classes;
  },

  SET_COLUMNS: (state, columns) => {
    state.columns = columns;
  },

  SET_CURRENT_PAGE: (state, currentPage) => {
    state.currentPage = currentPage;
  },

  SET_DATE_RANGE: (state, dateRange) => {
    state.dateRange = dateRange;
  },

  SET_PAGE_SIZE: (state, pageSize) => {
    state.pageSize = pageSize;
  },

  SET_TOTAL_COUNT: (state, count) => {
    state.count = count;
  },

  SET_REFRESH_DATE: (state, timestamp) => {
    state.lastRefreshDate = timestamp;
  },

  SET_ORDERING: (state, ordering) => {
    state.ordering = ordering;
  },

  SET_FILTER: (state, { key, value }) => {
    Vue.set(state.filters, key, value);
  },

  RESET_FILTERS: state => {
    state.filters = {};
  },

  SET_MISSING_FEEDBACK_COUNT: (state, missingFeedbackClassesCount) => {
    state.missingFeedbackClassesCount = missingFeedbackClassesCount;
  },
};

export default mutations;
